module.exports = __webpack_public_path__ + "static/media/car4.0993ab37.jpg";